import * as React from 'react';

import styled, { css } from 'styled-components';

import Flex, { FlexProps } from '@components/layout/flex';

interface TextWrapperProps extends FlexProps {
  className?: string;
  children: React.ReactNode;
  isRead: boolean;
}

const TextWrapper: React.FC<TextWrapperProps> = (props) => {
  return <Flex className={`${props.className || ''}`}>{props.children}</Flex>;
};

export default styled(TextWrapper)`
  flex-wrap: wrap;
  & > span {
    color: ${(props) =>
      props.isRead
        ? css`
            ${({ theme }) => theme.colors.tertiary};
          `
        : css`
            ${({ theme }) => theme.colors.primary};
          `};
  }
`;
